import { MutationToasts, useMutation } from '../api-client'

export const ADMIN_MARKETPLACE_QUERY_KEYS = ['admin', 'marketplace']

//-------------------------------------------------------------------------
// Mutations
//-------------------------------------------------------------------------

export const useUploadMarketplaceSellers = (toasts: MutationToasts = {}) => {
  return useMutation<FormData, void>({
    method: 'post',
    url: '/admin/marketplace',
    collectionKeys: ADMIN_MARKETPLACE_QUERY_KEYS,
    ...toasts,
  })
}
